var exports = {
  "w": "comment-indicator__RxQI74",
};

module.exports = exports;
